<div
    id="content-wrapper"
    class="content-wrapper"
    [ngClass]="{
        'loading':isLoading,
        'idle':!isLoading,
        'sidebar-on':sidebarToggled,
        'sidebar-off':!sidebarToggled,
        'workspaces-on': (activeSidebarItem=='workspaces'),
        'dataspace-on': (activeSidebarItem=='dataspace'),
        'integrations-on': (activeSidebarItem=='integrations'),
    }"
>
    <app-sidebar></app-sidebar>
    <div class="main-content">
        <router-outlet></router-outlet>
    </div>
</div>
